import React, { useEffect, useState } from 'react';
import { Header } from './Header';
import { RestaurantBrand } from './RestaurantBrand';
// import { PromotionalOffer } from './PromotionalOffer';
import { LoyaltyRewards } from './LoyaltyRewards';
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import aladipattiyan from "../assets/aaladippattiyan_logo.png";
import mangoDiamond from "../assets/mango_diamond.png";
import CouponLeaf from './coupon/coupon';

export const Dashboard = ({ userPhone, handleLogout }) => {
  const [userDetails, setUserDetails] = useState({
    name: '',
    email: '',
    phone: userPhone,
    coins: 0,
    tier: 'Bronze',
    expiryDate: 'Nov 17, 2025'
  });

  useEffect(() => {
    const fetchUser = async () => {
      if (!userPhone) return;
      const userRef = doc(db, 'users', userPhone);
      const snap = await getDoc(userRef);
      if (snap.exists()) {
        const data = snap.data();
        setUserDetails({
          name: data.name || '',
          email: data.email || 'Not provided',
          phone: data.phone || userPhone,
          coins: data.coins || 0,
          tier: data.tier || 'Bronze',
          expiryDate: data.expiryDate || 'Nov 17, 2025'
        });
      }
    };

    fetchUser();
  }, [userPhone]);

  return (
    <div className="space-y-6">
      {/* Mobile Layout */}
      <div className="lg:hidden">
        <Header
          userName={userDetails.name}
          coinBalance={userDetails.coins}
          expiryDate={``}
          phoneNumber={userDetails.phone}
          onLogout={handleLogout}
        />
        {/* <RestaurantBrand /> */}
        {/* <PromotionalOffer /> */}
        <div className="mt-8">
          <h2 className="text-lg font-semibold text-gray-800 px-4 mb-4">Available Coupons</h2>
          <LoyaltyRewards />
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="hidden lg:block max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Left Column - User Info */}
          <div className="lg:col-span-1 space-y-6 sticky top-8 self-start">
            {/* User Card with Background */}
            <div
              className="relative text-black px-6 py-12 rounded-2xl"
              style={{
                backgroundImage: `url(${mangoDiamond})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="absolute inset-0 bg-black/10 rounded-b-3xl"></div>

              {userPhone && (
                <div className="absolute top-3 right-2 bg-black bg-opacity-50 px-3 py-1 rounded-full">
                  <span className="text-white text-sm">{userPhone}</span>
                </div>
              )}

              <h1 className="text-2xl font-bold mb-4 relative z-10">Hello {userDetails.name}</h1>
              <p className="text-black/90 mb-6 font-medium relative z-10 text-lg">
                {/* You have <span className="text-orange-400 font-semibold">{userDetails.coins} Aaladipattiyan Coins</span> */}
              </p>
            </div>

            {/* Brand Card */}
            {/* <div className="bg-gradient-to-r from-yellow-300 to-orange-300 rounded-2xl shadow-lg p-8">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-20 h-20 bg-gradient-to-br from-yellow-400 to-orange-400 rounded-full flex items-center justify-center">
                  <img src={aladipattiyan} alt="logo" />
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-gray-800">Aaladipattiyan</h2>
                  <p className="text-gray-900">நலனும் நற்சுவையும்</p>
                </div>
              </div>
            </div> */}
          </div>

          {/* Right Column - Main Content */}
          <div className="lg:col-span-2 space-y-6">
            {/* <PromotionalOffer /> */}

            <div className="bg-white rounded-2xl shadow-lg p-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-6">Available Coupons</h2>
              <LoyaltyRewards />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
